import React from "react";
import classes from "./BottomNavbar.module.css";
import { useNavigate } from "react-router-dom";

const BottomNavbar = ({ active }) => {
  const navigate = useNavigate();

  const navigateHandler = (path) => {
    navigate(path);
  };
  return (
    <div className={classes.bottom_navbar}>
      <div className={classes.bottom_navbar_container}>
        <div
          className={classes.item_container}
          onClick={() => navigateHandler("/home")}
        >
          <span className={`${active == 1 ? classes.active : classes.span}`}>
            <i className={`fa-solid fa-house-chimney ${classes.icon}`}></i>
          </span>
        </div>
        <div
          className={classes.item_container}
          onClick={() => navigateHandler("/levels")}
        >
          <span className={`${active == 2 ? classes.active : classes.span}`}>
            <i className={`fa-solid fa-gamepad ${classes.icon}`}></i>
          </span>
        </div>
        <div
          className={classes.item_container}
          onClick={() => navigateHandler("/terms")}
        >
          <span className={`${active == 3 ? classes.active : classes.span}`}>
            <i className={`fa-solid fa-file-invoice ${classes.icon}`}></i>
          </span>
        </div>
        <div
          className={classes.item_container}
          onClick={() => navigateHandler("/account")}
        >
          <span className={`${active == 4 ? classes.active : classes.span}`}>
            <i className={`fa-solid fa-user ${classes.icon}`}></i>
          </span>
        </div>
      </div>
    </div>
  );
};

export default BottomNavbar;
